import { render, staticRenderFns } from "./PointsHistoryContainer.vue?vue&type=template&id=4bbc70df&scoped=true"
import script from "./PointsHistoryContainer.vue?vue&type=script&lang=ts"
export * from "./PointsHistoryContainer.vue?vue&type=script&lang=ts"
import style0 from "./PointsHistoryContainer.vue?vue&type=style&index=0&id=4bbc70df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbc70df",
  null
  
)

export default component.exports